"use client";

import React from "react";
import { Cpu, MonitorSmartphone, Wrench, Headphones } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Diritto Societario",
  description: "Assistenza strategica nella gestione societaria, dalla costituzione alle operazioni straordinarie di fusione e acquisizione.",
  icon: Cpu
}, {
  title: "Contrattualistica",
  description: "Redazione e negoziazione di contratti commerciali complessi per proteggere i vostri interessi in ogni transazione nazionale.",
  icon: MonitorSmartphone
}, {
  title: "Contenzioso Civile",
  description: "Rappresentanza legale esperta in controversie civili e commerciali, con un focus sulla risoluzione rapida dei conflitti.",
  icon: Wrench
}, {
  title: "Consulenza del Lavoro",
  description: "Gestione specialistica delle relazioni industriali e dei rapporti di lavoro per garantire la piena conformità normativa aziendale.",
  icon: Headphones
}];
export default function CustomerServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}